
import { defineComponent, ref, onMounted, nextTick } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { rutEsValido, formatRut, yupIsRut } from "@/core/validators/YupRut";

interface ProfileDetails {
  rutProveedor: string;
  rut: string;
  codigoRol: string;
  proveedorId: number;
  nombres: string;
  apellidos: string;
  telefono: number;
  email: string;
  debeCambiarClave: boolean;
}
interface ProfileProveedor {
  rutProveedor: string;
  id: number;
  nombreProveedor: string;
}

export default defineComponent({
  name: "add-usuario-modal",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      form: {
        rut: "",
        rutProveedor: "",
      },
    };
  },
  methods: {
    formatRut() {
      this.form.rut = formatRut(this.form.rut);
    },
    formatRutProveedor() {
      this.form.rutProveedor = formatRut(this.form.rutProveedor);
    },
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const validado = ref(false);
    const proveedor = ref<ProfileProveedor>();
    Yup.addMethod(Yup.string, "yupIsRut", function (mensaje) {
      const { message } = mensaje;
      return this.test("yupIsRut", message, function (value) {
        const { path, createError } = this;
        const { some, more, args } = mensaje;
        // [value] - value of the property being tested
        // [path]  - property name,
        // ...
        return rutEsValido(value);
      });
    });

    const submitButton = ref<HTMLButtonElement | null>(null);
    const usuario = Yup.object().shape({
      rutProveedor: Yup.string()
        .test("yupIsRut", "Rut ingresado no es valido", function (value) {
          return rutEsValido(value);
        })
        .required("Es requerido")
        .label("Rut"),
      rut: Yup.string()
        .test("yupIsRut", "Rut ingresado no es valido", function (value) {
          return rutEsValido(value);
        })
        .required("Es requerido")
        .label("Rut"),
      nombres: Yup.string().required("Es requerido").label("Nombre"),
      apellidos: Yup.string().required("Es requerido").label("Nombre"),
      email: Yup.string()
        .min(4)
        .required("Es requerido")
        .email("No es válido")
        .label("Email"),
      telefono: Yup.number().required("Es requerido").label("Teléfono"),
      //tipo: Yup.string().required("Es requerido").label("Tipo"),
      //comentario: Yup.string().required("Es requerido").label("Comentario"),
    });
    onMounted(() => {
      console.log(0);
    });

    const consultarProveedor = ($event) => {
      const rut = $event.target.value;
      store
        .dispatch(Actions.GET_PROVEEDOR_RUT, rut)
        .then(() => {
          proveedor.value = store.getters.currentProveedor;
          Swal.fire({
            text: "Proveedor existe. Puedes continuar!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            validado.value = true;
          });
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
          Swal.fire({
            text: store.getters.getProveedorErrors[error],
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Intentar nuevamente!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };

    const onSubmitUsuario = (values) => {
      // eslint-disable-next-line
      submitButton.value!.disabled = true;
      values.proveedorId = proveedor.value?.id;
      values.telefono = parseInt(values.telefono);
      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");
      // Dummy delay
      setTimeout(() => {
        // Send login request
        store
          .dispatch(Actions.INS_USUARIO, values)
          .then(() => {
            Swal.fire({
              text: "El usuario del proveedor se ha creado correctamente. Hemos enviado un correo electrónico con la información de bienvenida!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              router.push({ name: "apps-customers-getting-started" });
            });
          })
          .catch(() => {
            const [error] = Object.keys(store.getters.getProveedorErrors);
            Swal.fire({
              text: store.getters.getProveedorErrors[error],
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Intentar nuevamente!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });

        submitButton.value?.removeAttribute("data-kt-indicator");
        // eslint-disable-next-line
        submitButton.value!.disabled = false;
      }, 1);
    };

    return {
      store,
      usuario,
      onSubmitUsuario,
      submitButton,
      consultarProveedor,
      proveedor,
      validado,
    };
  },
});
